export class ChartPoint {
  constructor(public x: number, public y: number) {
  }
}
